import { Form } from 'antd'
import React, { FunctionComponent } from 'react'
import './floatingLabel.scss'
import { FormOutlined } from '@ant-design/icons'
interface FloatingLabelProps {
  labelText: string
  children: React.ReactElement
  active: boolean
  value?: string
  name: string
  isProfilePage?: boolean
}

const FloatingLabel: FunctionComponent<FloatingLabelProps> = ({
  active,
  children,
  labelText,
  name,
  isProfilePage,
}) => {
  return (
    <Form.Item
      noStyle
      shouldUpdate={(prevValues, currentValues) =>
        prevValues[name] !== currentValues[name]
      }
    >
      {({ getFieldValue }) => (
        <div style={{ display: 'flex', flexFlow: 'column-reverse' }}>
          {children}
          <span
            className={`label ${
              active || getFieldValue(name) ? 'floatingLabel' : ''
            }`}
          >
            {labelText}
            {isProfilePage ? <FormOutlined /> : null}
          </span>
        </div>
      )}
    </Form.Item>
  )
}

export default FloatingLabel
